module.exports = require("@bechtel/client-assets/dist/images/arc-stryker-small-logo.svg");